















































































































































































import previewDialog from "../staffSalary/detail/previewDialog.vue";
import { getOrderMeritPayDetailApi } from "@/api/salary";
import lessonDetailDialog from "./lessonDetailDialog.vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    previewDialog,
    lessonDetailDialog,
  },
})
export default class extends Vue {
  detailData = {
    salary_staff_order: {
      group_one_type: 0,
      group_two_type: 0,
      calculate_type: 0,
    },
    staff_item: [] as any[],
    merit_pay: [] as any[],
    staff: {},
  };
  groupOneTypeZh = {
    0: "-",
    1: "统一设置",
    2: "按班级设置",
    3: "按课程设置",
  };
  groupTwoTypeZh = {
    0: "-",
    1: "综合统计",
    2: "按课次单独统计",
  };
  calculateTypeZh = {
    0: "-",
    1: "无梯度",
    2: "超额累计",
    3: "全额累计",
  };
  created() {
    const salary_id = Number(this.$route.query.salary_id);
    const staff_id = Number(this.$route.query.staff_id);
    if (!salary_id || !staff_id) {
      return false;
    }
    getOrderMeritPayDetailApi({
      salary_id: salary_id,
      staff_id: staff_id,
    }).then((res: any) => {
      // 合计工资
      if (res.data.staff_item.length > 0) {
        let wagesTotal = 0;
        res.data.staff_item.map((item: any) => {
          if (item.preset_id !== 2) {
            wagesTotal =
              item.item_type === 1
                ? (wagesTotal += Number(item.amount))
                : (wagesTotal -= Number(item.amount));
          }
        });
        res.data.staff_item.push({
          amount: Math.abs(wagesTotal),
          item_id: 0,
          item_name: "合计",
          item_type: wagesTotal > 0 ? 1 : 2,
          org_id: 0,
          preset_id: 0,
          salary_id: 0,
          staff_id: 0,
        });
      }
      this.detailData = res.data;
    });
  }
}
